import { gql } from '@apollo/client';

export const TRIGGER_ENERGY_CREDIT_SUBMISSION_EXPORT = gql`
  mutation TriggerEnergyCreditSubmissionExport {
    TriggerEnergyCreditSubmissionExport {
      Success
    }
  }
`;

export const TRIGGER_HEAT_PUMP_INVOICE_SYNC = gql`
  mutation TriggerHeatPumpInvoiceSync {
    TriggerHeatPumpInvoiceSync {
      Success
    }
  }
`;

export const TRIGGER_CLAYTON_GO_TO_NEXT_DATA_SYNC = gql`
  mutation TriggerClaytonGoToNextDataSync($facilityId: ID!) {
    TriggerClaytonGoToNextDataSync(Id: $facilityId) {
      Success
    }
  }
`;

export const GET_EXPORTABLE_SUBMISSIONS = gql`
  query GetExportableSubmissions {
    GetExportableSubmissions {
      Count
    }
  }
`;

export const TRIGGER_DUPLICATE_SUBMISSIONS_CLEANUP = gql`
  mutation TriggerDuplicateSubmissionsCleanup {
    TriggerDuplicateSubmissionsCleanup {
      Success
    }
  }
`;

export const DELETE_DATABASE_INSPECTION = gql`
  mutation DeleteDatabaseInspection($payload: String!) {
    DeleteDatabaseInspection(Payload: $payload) {
      Success
      Message
      UpdatedData
    }
  }
`;

export const MIGRATE_INSPECTION_PROGRESS_TO_S3 = gql`
  mutation MigrateInspectionProgressToS3 {
    MigrateInspectionProgressToS3 {
      TotalFound
      Succeeded
      Failed
      FailedKeys
    }
  }
`;
